var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for TikTok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9726 0C20.5006 4.54095 23.0351 7.24824 27.4416 7.53624V12.6436C24.8879 12.8932 22.6511 12.058 20.0494 10.4835V20.0359C20.0494 32.1706 6.82014 35.9628 1.50157 27.2649C-1.91614 21.6679 0.176728 11.8468 11.1403 11.4532V16.8389C10.3051 16.9734 9.41223 17.1846 8.5962 17.463C6.15772 18.2886 4.77528 19.8342 5.15929 22.5607C5.89851 27.7833 15.4796 29.329 14.6828 19.1238V0.00960031H19.9726V0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.708ed27b628a5e3ba38924d930f498d6.svg";
export { ForwardRef as ReactComponent };